import React from 'react';
import ResultsPage from '../containers/ResultsPage.jsx';

export default (props) => (
  <ResultsPage {...props} />
);
